(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('unitPromotions', UnitPromotions);

    /** @ngInject */
    function UnitPromotions($rootScope, UnitService, HelperService, NotifyService, sweetAlert, PATHS) {
        function UnitPromotionsDirectiveController($scope) {
            const vm = this;

            let removeWatchShow = $scope.$watch('vm.show', (newValue) => {
                if (newValue)
                    init();
            });

            $scope.$on('$destroy', () => {
                removeWatchShow();
            });

            vm.flowFileAdded = ($file, $flow) => {
                let extension = ($file.getExtension() || '').toLowerCase();
                let blacklist = ['png', 'gif', 'jpg', 'jpeg', 'bmp'];

                if (!blacklist.includes(extension)) {
                    NotifyService.error('Apenas imagens nos formatos: PNG, JPG, JPEG, BMP ou GIF são permitidas.');
                    HelperService.setErrorMessageForm('.promotion-banner-upload', 'Formato inválido.', true);
                    return false;
                }

                angular.extend($flow.opts, vm.flowOptionsBanner);
                HelperService.removeErrorMessageForm('.promotion-banner-upload');

                return true;
            };

            vm.flowFileSubmitted = $flow => {
                $flow.upload();
            };

            vm.flowFileFinished = ($file, $message) => {
                let message = angular.fromJson($message);

                vm.form.BannerUrl = message.FileSaveName;
            };

            vm.flowFileError = $flow => {
                $flow.files = [];
                NotifyService.error('Não foi possível enviar o banner da promoção.');
            };

            vm.setEdit = promotion => {
                vm.form = {
                    Id: promotion.Id,
                    UnitId: vm.unitData.Id,
                    PromotionName: promotion.PromotionName,
                    BannerUrl: promotion.BannerUrl,
                    BannerUrlAzure: promotion.BannerUrlAzure,
                    TargetUrl: promotion.TargetUrl,
                    StartsAtLocal: moment(promotion.StartsAt).format('YYYY-MM-DDTHH:mm'),
                    EndsAtLocal: moment(promotion.EndsAt).format('YYYY-MM-DDTHH:mm'),
                    Active: promotion.Active
                };
            };

            vm.cancelEdit = () => {
                resetForm();
            };

            vm.save = () => {
                if (!vm.form.PromotionName || !vm.form.PromotionName.trim()) {
                    NotifyService.error('Informe o nome da promoção.');
                    return;
                }

                if (!vm.form.StartsAtLocal || !vm.form.EndsAtLocal) {
                    NotifyService.error('Informe início e fim da vigência.');
                    return;
                }

                let startsMoment = moment(vm.form.StartsAtLocal);
                let endsMoment = moment(vm.form.EndsAtLocal);

                if (!startsMoment.isValid() || !endsMoment.isValid()) {
                    NotifyService.error('Datas de vigência inválidas.');
                    return;
                }

                if (endsMoment.isBefore(startsMoment)) {
                    NotifyService.error('A data final deve ser maior ou igual à data inicial.');
                    return;
                }

                let payload = {
                    Id: vm.form.Id,
                    UnitId: vm.unitData.Id,
                    PromotionName: vm.form.PromotionName,
                    BannerUrl: vm.form.BannerUrl,
                    TargetUrl: vm.form.TargetUrl,
                    StartsAt: startsMoment.format('YYYY-MM-DDTHH:mm:ssZ'),
                    EndsAt: endsMoment.format('YYYY-MM-DDTHH:mm:ssZ'),
                    Active: vm.form.Active
                };

                HelperService.startLoading('.loading-holder');

                let request = payload.Id
                    ? UnitService.putPromotion(payload)
                    : UnitService.postPromotion(payload);

                request.then(() => {
                    resetForm();
                    loadPromotions();
                    HelperService.stopLoading('.loading-holder');
                    HelperService.successCallback(payload.Id ? 'update' : 'create');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                });
            };

            vm.delete = promotion => {
                sweetAlert.swal({
                    title: 'Você tem certeza?',
                    text: 'Não é possível desfazer essa ação!',
                    type: 'warning',
                    confirmButtonText: 'Sim, tenho certeza',
                    showCancelButton: true,
                    cancelButtonText: 'Não, cancelar',
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (!response.value)
                        return;

                    HelperService.startLoading('.loading-holder');

                    UnitService
                        .deletePromotion(promotion.Id)
                        .then(() => {
                            vm.promotions = vm.promotions.filter(x => x.Id !== promotion.Id);
                            HelperService.stopLoading('.loading-holder');
                            HelperService.successCallback('delete');
                        }, error => {
                            HelperService.stopLoading('.loading-holder');
                            HelperService.errorCallback(error);
                        });
                });
            };

            vm.getBannerDisplay = promotion => {
                if (!promotion)
                    return '';

                if (promotion.BannerUrlAzure)
                    return promotion.BannerUrlAzure;

                if (!promotion.BannerUrl)
                    return '';

                return HelperService.imageHandlerPath('unit-promotion', vm.unitData.Id, promotion.BannerUrl);
            };

            vm.getBannerDisplayFromForm = () => {
                if (!vm.form)
                    return '';

                if (vm.form.BannerUrlAzure)
                    return vm.form.BannerUrlAzure;

                if (!vm.form.BannerUrl)
                    return '';

                return HelperService.imageHandlerPath('unit-promotion', vm.unitData.Id, vm.form.BannerUrl);
            };

            vm.formatDate = value => {
                if (!value)
                    return '-';

                return moment(value).format('DD/MM/YYYY HH:mm:ss Z');
            };

            function loadPromotions() {
                if (!vm.unitData || !vm.unitData.Id)
                    return;

                UnitService
                    .getPromotions(vm.unitData.Id)
                    .then(success => {
                        vm.promotions = success || [];
                    }, error => {
                        HelperService.errorCallback(error);
                    });
            }

            function resetForm() {
                vm.form = {
                    Id: 0,
                    UnitId: vm.unitData.Id,
                    PromotionName: '',
                    BannerUrl: '',
                    BannerUrlAzure: '',
                    TargetUrl: '',
                    StartsAtLocal: '',
                    EndsAtLocal: '',
                    Active: true
                };
            }

            function initVars() {
                vm.canUserCreate = $rootScope.canUserCreate;
                vm.canUserEdit = $rootScope.canUserEdit;
                vm.isReadOnly = vm.readOnly || !(vm.canUserCreate || vm.canUserEdit);

                vm.promotions = [];
                vm.flowOptionsBanner = {
                    query: () => {
                        return {
                            Path: `unit-promotion/${vm.unitData.Id}`,
                            CreateThumb: false,
                            CreateThumbAdmin: false
                        };
                    }
                };

                angular.extend(vm.flowOptionsBanner, HelperService.getFlowOptionsDefaults());
            }

            function init() {
                initVars();
                resetForm();
                loadPromotions();
            }
        }

        return {
            bindToController: true,
            controller: UnitPromotionsDirectiveController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/unit-promotions/unit-promotions.html`,
            scope: {
                unitData: '=',
                show: '=',
                readOnly: '=?'
            }
        };
    }
}());
